import { isEmpty } from 'lodash';
import TranslationIds from '../../../../commons/translationIds';

export const APIErrors = {
    InvalidParameterException: {
        title: 'Invalid Input Paramters',
        message: 'Please check your input and try again.',
    },

    NotAuthorizedException: {
        title: 'Oops!',
        message: 'It seems you mistyped your email or password.',
    },

    InternalServerError: {
        title: TranslationIds.COMPONENT_OOPS,
        message: TranslationIds.USER_OOPS_PAGE_TECH_PROB
    },

    INVALID_API_KEY: {
        title: TranslationIds.ERROR_API_UNAVAILABLE_TITLE,
        message: TranslationIds.ERROR_API_UNAVAILABLE_DESCRIPTION
    },

    INVALID_BUTTON_ID: {
        title: TranslationIds.ERROR_DISPLAY_UNAVAILABLE_TITLE,
        message: TranslationIds.ERROR_DISPLAY_UNAVAILABLE_DESCRIPTION
    },

    BUTTON_NOT_LIVE: {
        title: TranslationIds.ERROR_DISPLAY_NOT_FOUND_TITLE,
        message: TranslationIds.ERROR_DISPLAY_NOT_FOUND_DESCRIPTION
    },
};


export function getApiErrorByCode (code) {
    if (!isEmpty(APIErrors[code])) {
        return APIErrors[code];
    }
    return APIErrors.InternalServerError;
}

export default APIErrors;